module.exports = __webpack_public_path__ + "img/premium-packages-modal-background.85ed597b.png";